import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTRPCContext, createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import type { ReactNode } from "react";
import type { ApiClient, AppRouter } from "./client";

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

/**
 * The same query keys and options as `useTRPC()`, outside React: for code
 * that writes to the cache on its own, such as staff-core's outbox.
 */
export function createQueryKeys(client: ApiClient, queryClient: QueryClient) {
	return createTRPCOptionsProxy<AppRouter>({ client, queryClient });
}

export {
	useInfiniteQuery,
	useMutation,
	useQuery,
	useQueryClient,
} from "@tanstack/react-query";

/** Provides TanStack Query and the typed tRPC options proxy (`useTRPC`). */
export function ApiProvider({
	client,
	queryClient,
	children,
}: {
	client: ApiClient;
	queryClient: QueryClient;
	children: ReactNode;
}) {
	return (
		<QueryClientProvider client={queryClient}>
			<TRPCProvider trpcClient={client} queryClient={queryClient}>
				{children}
			</TRPCProvider>
		</QueryClientProvider>
	);
}
